var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flip-number',{attrs:{"value":_vm.value}}),_c('button',{on:{"click":_vm.handleAdd}},[_vm._v("add")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }